import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { StoreItem } from './store-item';

@Component({
  selector: 'store-component',
  template: `
    <div class="toolbar">
      @if (searchable) {
        <div class="table-controls-row">
          <va-search-box (update)="filterTerm = $event"></va-search-box>
        </div>
      }
    </div>
    <div class="row row-gutters">
      @for (item of filteredItems; track item) {
        <div class="col-flex">
          <store-card
            [item]="item"
            [currencyCode]="currencyCode"
            (cardClicked)="this.itemClicked.emit(item)"
            [showAllPrices]="showAllPrices"
          ></store-card>
        </div>
      }
    </div>
    `,
  styleUrls: ['./store.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StoreComponent {
  @Input() items: StoreItem[] = [];
  @Input() currencyCode: string;
  @Input() showAllPrices = false;
  @Input() searchable = true;

  @Output() itemClicked = new EventEmitter<StoreItem>();

  filterTerm: string;

  get filteredItems(): StoreItem[] {
    if (this.filterTerm) {
      return this.items.filter((pkg) => pkg.name.toLowerCase().indexOf(this.filterTerm.toLowerCase()) !== -1);
    }
    return this.items;
  }
}
